import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, onUnmounted, ref } from 'vue'

import PromoBanner from '@/components_new/PromoItems/PromoBanner.vue'
import { useAppStore } from '@/store/app-store'

import RotateIcon from './icons/rotate.svg'

type Orientation = 'horizontal' | 'vertical'
interface RotateMessageProps {
    orientation: Orientation[]
    class?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RotateBanner',
  props: {
    orientation: {},
    class: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { platform } = useAppStore()
const beenInCorrectOrientation = ref(false)

const shouldRotate = ref(false)

const portraitMediaQuery = ref<MediaQueryList | null>(null)

const emit = __emit

const onOrientationChange = () => {
    const screenOrientation = portraitMediaQuery.value?.matches ? 'vertical' : 'horizontal'
    if (props.orientation.includes(screenOrientation)) {
        beenInCorrectOrientation.value = true
        shouldRotate.value = false
    } else {
        shouldRotate.value = true
    }
}

onMounted(() => {
    if (platform !== 'desktop' && props.orientation.length !== 2) {
        portraitMediaQuery.value = window.parent.matchMedia('(orientation: portrait)')
        // temp solution for widgets
        portraitMediaQuery.value.addEventListener('change', onOrientationChange)
        onOrientationChange()
    } else {
        beenInCorrectOrientation.value = true
    }
})

onUnmounted(() => {
    portraitMediaQuery.value?.removeEventListener('change', onOrientationChange)
})

return (_ctx: any,_cache: any) => {
  return (shouldRotate.value)
    ? (_openBlock(), _createBlock(PromoBanner, {
        key: 0,
        image: { src: _unref(RotateIcon), alt: _ctx.$tr('rotateMessage.rotate'), height: '64px', width: '64px' },
        description: _ctx.$tr('rotateMessage.message', { orientation: props.orientation[0] }),
        titleProps: { type: 'label', size: 'l' },
        direction: "row",
        class: _normalizeClass([_ctx.$style.banner, props.class]),
        title: _ctx.$tr('rotateMessage.rotate'),
        textAlign: "left",
        closeBtnProps: { visual: 'fill' },
        onClosePromo: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, null, 8, ["image", "description", "class", "title"]))
    : _createCommentVNode("", true)
}
}

})